import {
  fetchV1Puchases,
  fetchV1Purchase,
  createV1Purchase,
} from "@/services/v1/purchaseAPIService";

export default {
  state: {
    purchases: [],
    purchase: null,
    purchasePageSize: 5,
    totalPurchaseCount: 0,
  },
  getters: {
    purchases: (state) => state.purchases,
    purchase: (state) => state.purchase,
    currentPurchasePageSize: (state) => state.purchasePageSize,
    totalPurchaseCount: (state) => state.totalPurchaseCount,
  },
  mutations: {
    SET_PURCHASES(state, purchases) {
      state.purchases = purchases;
    },
    SET_PURCHASE(state, purchase) {
      state.purchase = purchase;
    },
    SET_PURCHASE_PAGE_SIZE(state, pageSize) {
      state.purchasePageSize = pageSize;
    },
    SET_TOTAL_PURCHASE_COUNT(state, count) {
      state.totalPurchaseCount = count;
    },
  },
  actions: {
    async fetchPurchases({ commit }, { page = 1, pageSize = 5, supplier = null } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Puchases(page, pageSize, supplier);
        commit("SET_PURCHASES", response.results);
        commit("SET_PURCHASE_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_PURCHASE_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching purchases:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async fetchPurchase({ commit }, purchaseCode) {
      try {
        const response = await fetchV1Purchase(purchaseCode);
        commit("SET_PURCHASE", response);
      } catch (error) {
        console.error("Error fetching purchase:", error);
        // const errorMessages = [];
        // for (const [key, value] of Object.entries(error.response.data)) {
        //   errorMessages.push(value);
        //   console.log(`Book fetch... ${key}: ${value}`);
        // }
        // commit("SET_BOOK_ERROR", errorMessages);
      } finally {
        // commit("SET_BOOK_LOADING", false);
        console.log("finally...");
      }
    },
    async addPurchase({ commit }, purchase) {
      try {
        const response = await createV1Purchase(purchase);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`purchase create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Purchase.";
        return { success: false, message };
      }
    },
  },
};
